import React, { useMemo } from "react"
import { twMerge } from "tailwind-merge"

type TColor = "legacy-light" | "legacy-dark" | "white"

interface TextProps {
  children?: React.ReactNode
  className?: string
  as?: "p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "base" | "label"
  color?: TColor
  htmlFor?: string
}

// p => text-sm
// span => text-[.7125rem] leading-3
// h1 => text-4xl font-bold
// h2 => text-3xl font-bold
// h3 => text-2xl font-bold
// h4 => text-xl font-bold
// h5 => text-lg font-bold
// h6 => text-xs font-bold

const Text = ({ children, className = "", as = "p", color = "legacy-dark", ...props }: TextProps) => {
  const colors = useMemo(() => {
    switch (color) {
      case "legacy-light":
        return "text-slate-600 dark:text-slate-400"
      case "legacy-dark":
        return "text-legacy-dark dark:text-legacy-cream"
      case "white":
        return "text-white"
    }
  }, [color])
  if (as === "p") {
    return (
      <p className={twMerge("text-sm ", className, colors)} {...props}>
        {children}
      </p>
    )
  } else if (as === "span") {
    return (
      <span className={twMerge("text-[.7125rem] leading-3 ", className, colors)} {...props}>
        {children}
      </span>
    )
  } else if (as === "h1") {
    return (
      <h1 className={twMerge("text-4xl font-bold ", className, colors)} {...props}>
        {children}
      </h1>
    )
  } else if (as === "h2") {
    return (
      <h2 className={twMerge("text-3xl font-bold ", className, colors)} {...props}>
        {children}
      </h2>
    )
  } else if (as === "h3") {
    return (
      <h3 className={twMerge("text-2xl font-bold ", className, colors)} {...props}>
        {children}
      </h3>
    )
  } else if (as === "h4") {
    return (
      <h4 className={twMerge("text-xl font-bold ", className, colors)} {...props}>
        {children}
      </h4>
    )
  } else if (as === "h5") {
    return (
      <h5 className={twMerge("text-lg font-bold ", className, colors)} {...props}>
        {children}
      </h5>
    )
  } else if (as === "h6") {
    return (
      <h6 className={twMerge("text-xs font-bold ", className, colors)} {...props}>
        {children}
      </h6>
    )
  } else if (as === "label") {
    return (
      <label className={twMerge("inline-block text-sm font-medium", className, colors)} {...props}>
        {children}
      </label>
    )
  }
  return (
    <p className={twMerge("text-base", className, colors)} {...props}>
      {children}
    </p>
  )
}

export default Text
